document.addEventListener('click', (e) => {
  const menu = e.target.closest('[data-fan-menu]');
  
  // Close all other menus
  document.querySelectorAll('[data-fan-menu]').forEach(m => {
    if (m !== menu) {
      const dd = m.querySelector('.fan-menu__dropdown');
      const btn = m.querySelector('.fan-menu__btn');
      if (dd) dd.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });

  if (!menu) return;

  const btn = menu.querySelector('.fan-menu__btn');
  const dd = menu.querySelector('.fan-menu__dropdown');
  if (!btn || !dd) return;

  // Toggle dropdown when button is clicked
  if (e.target.closest('.fan-menu__btn')) {
    const isOpen = !dd.hidden;
    dd.hidden = isOpen;
    btn.setAttribute('aria-expanded', String(!isOpen));
    e.preventDefault();
  }
});

// Close on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.fan-menu__dropdown').forEach(dd => {
      dd.hidden = true;
    });
    document.querySelectorAll('.fan-menu__btn').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });
  }
});
